import api from '../api';

const endpointFor = kind => {
  if (kind === 'students') return '/student-management/bulk-trash';
  if (kind === 'attendees') return '/attendee-management/bulk-trash';
  throw new Error('Módulo inválido para exclusão de cadastros.');
};
const requestOptions = { skipGlobalErrorModal: true, skipTransientRetry: true };
export const previewPersonBulkTrash = kind => api.get(`${endpointFor(kind)}/preview`, requestOptions).then(response => response.data);
export const confirmPersonBulkTrash = (kind, { password, confirmed, preview }) => api.post(endpointFor(kind), {
  password,
  confirmed: confirmed === true,
  previewToken: preview?.previewToken,
}, requestOptions).then(response => response.data);
